import { render } from "./SubmenuTopAds.vue?vue&type=template&id=ba21c47a"
import script from "./SubmenuTopAds.vue?vue&type=script&lang=js"
export * from "./SubmenuTopAds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__